import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  EnvironmentProviders,
  inject,
  InjectionToken,
  ModuleWithProviders,
  NgModule,
  provideAppInitializer,
  Provider,
} from '@angular/core';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { CallbackComponent } from './callback/callback.component';
import { PlatformHttpInterceptor } from './interceptor/platform.interceptor';
import { SecurityConfig } from './interface';
import { ToegangProvider } from './providers';
import { WebappService } from './providers/webapp/webapp.service';
import { AuthService, PlatformService, UserService } from './service';

export const AuthConfigToken = new InjectionToken<SecurityConfig>('AuthConfig');

@NgModule({
  imports: [OAuthModule.forRoot(), CallbackComponent],
  providers: [
    UserService,
    ToegangProvider,
    { provide: AuthService, useFactory: () => new AuthService() },
    { provide: PlatformService, useFactory: () => new PlatformService() },
    WebappService,
    { provide: OAuthStorage, useFactory: () => localStorage },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class SecurityModule {
  static forRoot(
    originalConfig: SecurityConfig,
  ): ModuleWithProviders<SecurityModule> {
    const config = originalConfig;
    const providers: Array<Provider | EnvironmentProviders> = [
      {
        provide: AuthConfigToken,
        useValue: config,
      },
      provideAppInitializer(() => {
        inject(AuthService);
      }),
    ];

    if (config.enableInterceptor !== false) {
      providers.push({
        provide: HTTP_INTERCEPTORS,
        useClass: PlatformHttpInterceptor,
        multi: true,
      });
    }

    return {
      ngModule: SecurityModule,
      providers,
    };
  }
}
